// bao migrate skip
import TabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
import baoMenu from "./../../services/bao-menu";
import GenericListTab from "./../../factories/generic-list-tab";
class ReminderTicketReferenceDocument extends GenericListTab {
    constructor(TabPage: TabPage, parent) {
        super(TabPage, parent);
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return null;
    }
    init() {
        return super.init().then(() => {
            baoMenu.registerEvent((action) => { this.CustomToolbarClick(action); });
        });
    }
    CustomToolbarClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "ReminderTicketReferenceDocumentDownload":
                    if (this.Selection()[0] != null) {
                        this.DownloadTicketReferenceDocument(this.Selection()[0].PrimaryKeyValue);
                    }
                    break;
            }
        }
    };
    DownloadTicketReferenceDocument(reminderticketReferenceDocumentId) {
        baoRouter.setHash("document/" + reminderticketReferenceDocumentId);
    }
    ;
}
export default ReminderTicketReferenceDocument;